import { Component } from '@angular/core';
import { CellRenderer } from '@shared/interfaces/table/cell-renderer';
import { CurrencyPipe } from '@angular/common';
import { CURRENCY_FORMAT } from '@app/core/constants/currency-format';

/**
 * Component responsible for rendering currency values in table cells.
 * Implements the CellRenderer interface for table integration.
 *
 * This component is primarily used through table column configurations to format
 * and display monetary values in tables. It uses Angular's CurrencyPipe for
 * consistent currency formatting across the application.
 *
 * ```typescript
 * {
 *   title: 'currency cell',
 *   key: 'amount',
 *   cellRenderer: CurrencyCellComponent,
 *   // Optional
 *   cellRendererParams: {
 *       format: 'USD',
 *   }
 * }
 * ```
 *
 */

@Component({
  selector: 'app-currency-cell',
  imports: [
    CurrencyPipe
  ],
  templateUrl: './currency-cell.component.html',
  styleUrl: './currency-cell.component.css'
})
export class CurrencyCellComponent extends CellRenderer {
  /**
   * Reference to the currency format configuration.
   * Used for consistent currency formatting across the component.
   * @protected
   */
  protected readonly CURRENCY_FORMAT = CURRENCY_FORMAT;

  /**
   * Reference to the Number global object.
   * Used for type conversion and number formatting operations.
   * @protected
   */
  protected readonly Number = Number;
}
